import { defineStore } from 'pinia';
import { getFans, getNumMaxSecrets, getSecrets, getMatchs } from '@/utils/utils.js';
import { Capacitor } from '@capacitor/core'

export const useDataStore = defineStore('data', {
  state: () => ({
    matchDone: false,
    matchs: [],
    fans: [],
    secrets: [],
    numMaxSecrets: 0,
    isHybrid: Capacitor.isNativePlatform(),
    // Estados de carga y error
    loading: false,
    error: null
  }),
  actions: {
    async loadData() {
      this.loading = true;
      this.error = null;
      try {
        this.fans = await getFans();
        this.numMaxSecrets = await getNumMaxSecrets();
        this.secrets = await getSecrets();
        this.matchs = await getMatchs();
      } catch (error) {
        this.error = 'error.general';
      } finally {
        this.loading = false;
      }
    },
    async loadSecrets() {
      try {
        this.secrets = await getSecrets();
      } catch (error) {
        this.error = 'error.general';
      }
    },
    async retry() {
      await this.loadData();
    },
    clearError() {
      this.error = null;
    }
  },
});